var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$mq,style:({width: (_vm.width + "px"), height: (_vm.height + "px")}),attrs:{"id":"gameplay"}},[(!_vm.isPhone)?_c('div',{staticClass:"gameContainer"},[_c('div',{attrs:{"id":"topPanel"}},[_c('Header',_vm._b({},'Header',{height: _vm.topHeight, isPhone: _vm.isPhone},false))],1),_c('div',{attrs:{"id":"communityPanel"}},[_c('Community',_vm._b({},'Community',Object.assign({}, _vm.communityDimensions,
          {colorsByHealth: _vm.colorsByHealth,
          tl: _vm.tl,
          phases: _vm.phases,
          playTimeline: _vm.playTimeline,
          setGroups: _vm.setGroups}),false)),_c('div',{attrs:{"id":"minimapContainer"}},[_c('Minimap',_vm._b({},'Minimap',Object.assign({}, _vm.minimapDimensions,
            {groups: _vm.groups,
            colorsByHealth: _vm.colorsByHealth,
            containerWidth: _vm.width,
            containerHeight: _vm.height}),false))],1),_c('div',{staticClass:"label",attrs:{"id":"populationContainer"}},[(_vm.cityCounty)?_c('h3',[_vm._v(_vm._s(_vm.$t('population.city', Object.assign({}, _vm.cityCounty))))]):_vm._e(),(_vm.population)?_c('div',[_vm._v(" "+_vm._s(_vm.$t('population.count', {count: _vm.formatNumber(_vm.population.total)}))+" ")]):_vm._e()]),(_vm.showDecision)?_c('Decide',_vm._b({},'Decide',{
          onUpdate: _vm.updateDecision,
          continueGame: _vm.continueGame,
          ageGroups: _vm.ageGroups,
          colorsByHealth: _vm.colorsByHealth,
        },false)):_vm._e()],1),_c('div',{style:({width: (_vm.rightWidth + "px")}),attrs:{"id":"rightPanel"}},[_c('CommunityStats',_vm._b({},'CommunityStats',{
        healthStatus: _vm.healthStatus,
        colorsByHealth: _vm.colorsByHealth,
        tl: _vm.tl,
        phases: _vm.phases,
        playTimeline: _vm.playTimeline,
      },false)),_c('Hospital',_vm._b({},'Hospital',{colorsByHealth: _vm.colorsByHealth, tl: _vm.tl, phases: _vm.phases, playTimeline: _vm.playTimeline},false))],1),_c('div',{attrs:{"id":"bottomPanel"}},[_c('Legend',_vm._b({},'Legend',{healthStatus: _vm.healthStatus, colorsByHealth: _vm.colorsByHealth},false)),_c('BarChart',_vm._b({},'BarChart',{
          height: _vm.bottomHeight,
          ageGroups: _vm.ageGroups,
          colorsByHealth: _vm.colorsByHealth,
          tl: _vm.tl,
          phases: _vm.phases,
          playTimeline: _vm.playTimeline,
        },false)),_c('LineChart',_vm._b({},'LineChart',{
          height: _vm.bottomHeight,
          ageGroups: _vm.ageGroups,
          colorsByHealth: _vm.colorsByHealth,
          tl: _vm.tl,
          phases: _vm.phases,
          playTimeline: _vm.playTimeline,
        },false))],1)]):_vm._e(),(_vm.isPhone)?_c('div',{staticClass:"gameContainer"},[_c('div',{staticClass:"panel",style:({top: (_vm.topHeight + "px")}),attrs:{"id":"communityPanel"}},[_c('Community',_vm._b({},'Community',Object.assign({}, {isPhone: _vm.isPhone},
          _vm.communityDimensions,
          {colorsByHealth: _vm.colorsByHealth,
          tl: _vm.tl,
          phases: _vm.phases,
          playTimeline: _vm.playTimeline,
          setGroups: _vm.setGroups}),false)),_c('div',{staticClass:"label",attrs:{"id":"populationContainer"}},[(_vm.cityCounty)?_c('h3',[_vm._v(_vm._s(_vm.$t('population.city', Object.assign({}, _vm.cityCounty))))]):_vm._e(),(_vm.population)?_c('div',[_vm._v(" "+_vm._s(_vm.$t('population.count', {count: _vm.formatNumber(_vm.population.total)}))+" ")]):_vm._e()])],1),_c('div',{staticClass:"panel",style:({
      bottom: (_vm.bottomHeight + "px"),
      height: (_vm.chartsHeight + "px"),
    }),attrs:{"id":"chartsPanel"}},[_c('div',[_c('Legend',_vm._b({},'Legend',{healthStatus: _vm.healthStatus, colorsByHealth: _vm.colorsByHealth, isPhone: _vm.isPhone},false)),_c('LineChart',_vm._b({},'LineChart',{
            isPhone: _vm.isPhone,
            height: 120,
            ageGroups: _vm.ageGroups,
            colorsByHealth: _vm.colorsByHealth,
            tl: _vm.tl,
            phases: _vm.phases,
            playTimeline: _vm.playTimeline,
          },false)),_c('Hospital',_vm._b({},'Hospital',{isPhone: _vm.isPhone, colorsByHealth: _vm.colorsByHealth, tl: _vm.tl, phases: _vm.phases, playTimeline: _vm.playTimeline},false)),_c('BarChart',_vm._b({},'BarChart',{
            isPhone: _vm.isPhone,
            height: 120,
            ageGroups: _vm.ageGroups,
            colorsByHealth: _vm.colorsByHealth,
            tl: _vm.tl,
            phases: _vm.phases,
            playTimeline: _vm.playTimeline,
          },false)),_c('div',{staticClass:"methodology label",domProps:{"innerHTML":_vm._s(_vm.$t('footnotes.fullMethodology'))}})],1)]),_c('div',{staticClass:"panel",attrs:{"id":"topPanel"}},[_c('Header',_vm._b({},'Header',{height: _vm.topHeight, isPhone: _vm.isPhone},false))],1),_c('div',{staticClass:"panel",style:({height: (_vm.bottomHeight + "px")}),attrs:{"id":"bottomPanel"}},[_c('CommunityStats',_vm._b({},'CommunityStats',{
          isPhone: _vm.isPhone,
          tl: _vm.tl, phases: _vm.phases,
          playTimeline: _vm.playTimeline,
        },false))],1),(_vm.showDecision)?_c('Decide',_vm._b({},'Decide',{
        isPhone: _vm.isPhone,
        onUpdate: _vm.updateDecision,
        continueGame: _vm.continueGame,
        ageGroups: _vm.ageGroups,
        colorsByHealth: _vm.colorsByHealth,
      },false)):_vm._e()],1):_vm._e(),(!_vm.isPhone)?_c('footer',{staticClass:"methodology label",style:({width: (_vm.width + "px")})},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.$t('footnotes.fullMethodology'))}})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }